module.exports = __webpack_public_path__ + "static/content_2_2_eg-56019134e03e6c0e1198662ddba81bdc.png";